import { DiScrum } from "react-icons/di";
import { FaAws, FaGitAlt, FaNodeJs, FaReact } from "react-icons/fa";
import {
  SiDocker,
  SiFastify,
  SiKubernetes,
  SiMongodb,
  SiNestjs,
  SiNextdotjs,
  SiPostgresql,
  SiPytorch,
  SiRedis,
  SiRust,
  SiTensorflow,
  SiTypescript,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

export interface TechIconConfig {
  icon: React.ComponentType;
  initialX: number;
  initialY: number;
  animateX: number;
  animateY: number;
  rotate: number;
  duration: number;
  top: string;
  left: string;
  size?: number;
  opacity?: number;
}

const getRandomPosition = () => Math.random() * 100;
const getRandomDuration = () => Math.floor(Math.random() * 30) + 15;
const getRandomSize = () => Math.random() * 1.5 + 1.5;
const getRandomOpacity = () => Math.random() * 0.3 + 0.2;

export const techIcons: TechIconConfig[] = [
  // Frontend
  {
    icon: FaReact,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiTypescript,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiNextdotjs,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },

  // Backend
  {
    icon: FaNodeJs,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiRust,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: TbBrandGolang,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiNestjs,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiFastify,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },

  // AI/ML
  {
    icon: SiTensorflow,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiPytorch,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },

  // DevOps & Cloud
  {
    icon: SiDocker,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiKubernetes,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: FaAws,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },

  // Databases
  {
    icon: SiMongodb,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiPostgresql,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: SiRedis,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },

  // Version Control & Methodology
  {
    icon: FaGitAlt,
    initialX: -100,
    initialY: getRandomPosition(),
    animateX: window.innerWidth,
    animateY: getRandomPosition(),
    rotate: 360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
  {
    icon: DiScrum,
    initialX: window.innerWidth,
    initialY: getRandomPosition(),
    animateX: -100,
    animateY: getRandomPosition(),
    rotate: -360,
    duration: getRandomDuration(),
    top: `${getRandomPosition()}%`,
    left: `${getRandomPosition()}%`,
    size: getRandomSize(),
    opacity: getRandomOpacity(),
  },
];
